var isProgrammaticChange = false;
setTimeout(() => {
    if ($(`.variant-metafield`)) {
      $(`.variant-metafield`).hide();
      $(`.variant-metafield[data-id=${ $('.variant-selection__variants option:selected').val() }]`).show();
    }
  }, 600);

$(document).on('change', '.product-options-index-1 .options-selection__option-value-input', function() {
    if (isProgrammaticChange) {
        return;
    }
    //console.log('change');
    var get_attr_val = $('.product-options-index-0').find('.options-selection__option-value-input:checked').attr('data-variant-option-available');
    //console.log(get_attr_val);
    if (get_attr_val == 'false') {
        //console.log('trigger');
        isProgrammaticChange = true;
        $('.product-options-index-0').find('input[type=radio][data-variant-option-available="true"]').first().click();
        isProgrammaticChange = false;
    }
  setTimeout(() => {
    if ($(`.variant-metafield`)) {
      $(`.variant-metafield`).hide();
      //console.log("Dropdown variant ID:", $('.variant-selection__variants option:selected').val())
      $(`.variant-metafield[data-id=${ $('.variant-selection__variants option:selected').val() }]`).show();
    }
  }, 600);
});

$(document).on('change', '.product-options-index-0 .options-selection__option-value-input', function() {
    if (isProgrammaticChange) {
        return;
    }
    //console.log('change');
    var get_attr_val = $('.product-options-index-1').find('.options-selection__option-value-input:checked').attr('data-variant-option-available');
    //console.log(get_attr_val);
    if (get_attr_val == 'false') {
        //console.log('trigger');
        isProgrammaticChange = true;
        $('.product-options-index-1').find('input[type=radio][data-variant-option-available="true"]').first().click();
        
        isProgrammaticChange = false;
    }
  
    setTimeout(() => {
      if ($(`.variant-metafield`)) {
        $(`.variant-metafield`).hide();
        //console.log("Variant ID down:", $('.variant-selection__variants option:selected').val())
        $(`.variant-metafield[data-id=${ $('.variant-selection__variants option:selected').val() }]`).show();
      }
    }, 600);
});